<section>

  <div class="flex justify-between items-end">
    <div>
      <h1>courses</h1>
    </div>
    <div>
      <!-- <button onclick="addclassModal.showModal()" class="btn btn-sm flex items-center btn-primary"><i
              class="ri-add-line"></i> Create class</button> -->
    </div>
  </div>

  <div class="my-5 w-max capitalize">
    <div role="tablist" class="tabs tabs-boxed gap-1">
      @for (i of tabs; track $index) {
      <a role="tab" class="tab text-nowrap " (click)="changeTab(i.value)"
        [ngClass]="{'tab-active': currentTab === i.value}">{{i.name}}</a>
      }   

    </div>
  </div>

  <ul class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">

    @if (isFetching) {
    <li class="col-span-full flex justify-center py-10">
      <app-loader></app-loader>
    </li>
    } @else {
    @if (courses && courses.length) {
    @for (i of courses; track $index) {
    <li class="bg-white border rounded-lg p-5" *ngIf="islistaccess">
      <a
        [routerLink]="['/course-detail', (i.course_type ? i.course_type.replace(' ','').toLowerCase() : 'all'), i.id]"
        routerLinkActive="router-link-active"
      >
        <img src="{{i.thumbnail}}" class="bg-slate-200 w-full h-[10rem] rounded-lg object-cover" alt="">
        <div class="mt-2">
          <h2 class="font-semibold capitalize line-clamp-2">{{i.course_name}}</h2>
          <span class="text-xs text-zinc-500">{{i.course_type || i.course_type_id || ''}}</span>
        </div>
      </a>
    </li>
    }
    } @else {
    <li class="col-span-full flex justify-center py-10">
      <p>No data to display.</p>
    </li>
    }
    }

  </ul>

  <div class="mt-5 flex justify-center">
    <app-pagination [data]="paginationData" (pageChange)="pageChange($event)"></app-pagination>
  </div>

</section>